import React from "react";

/** Chart-down icon — Figma 18355:110553 */
export const ChartDownIcon = ({ className = "", size = 34 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 33.6 33.6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M29.4016 15.3983C29.0303 15.3983 28.6742 15.5458 28.4117 15.8084C28.1491 16.0709 28.0016 16.427 28.0016 16.7983V20.4243L19.1956 11.6043C19.0655 11.4731 18.9106 11.3689 18.74 11.2979C18.5694 11.2268 18.3864 11.1902 18.2016 11.1902C18.0168 11.1902 17.8338 11.2268 17.6632 11.2979C17.4926 11.3689 17.3378 11.4731 17.2076 11.6043L12.6016 16.2243L5.19563 8.80431C4.932 8.54068 4.57445 8.39258 4.20163 8.39258C3.8288 8.39258 3.47125 8.54068 3.20763 8.80431C2.944 9.06793 2.7959 9.42548 2.7959 9.79831C2.7959 10.1711 2.944 10.5287 3.20763 10.7923L11.6076 19.1923C11.7378 19.3235 11.8926 19.4277 12.0632 19.4988C12.2338 19.5698 12.4168 19.6064 12.6016 19.6064C12.7864 19.6064 12.9694 19.5698 13.14 19.4988C13.3106 19.4277 13.4655 19.3235 13.5956 19.1923L18.2016 14.5723L26.0276 22.3983H22.4016C22.0303 22.3983 21.6742 22.5458 21.4117 22.8084C21.1491 23.0709 21.0016 23.427 21.0016 23.7983C21.0016 24.1696 21.1491 24.5257 21.4117 24.7883C21.6742 25.0508 22.0303 25.1983 22.4016 25.1983H29.4016C29.5846 25.1961 29.7653 25.158 29.9336 25.0863C30.2757 24.9442 30.5476 24.6724 30.6896 24.3303C30.7614 24.162 30.7994 23.9813 30.8016 23.7983V16.7983C30.8016 16.427 30.6541 16.0709 30.3916 15.8084C30.129 15.5458 29.7729 15.3983 29.4016 15.3983Z"
      fill="currentColor"
    />
  </svg>
);

/** Chevron right — Figma 18355:110561 (rotated down-chevron) */
export const ChevronRightIcon = ({ className = "", size = 28 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.5 7L17.5 14L10.5 21"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
